module.exports = __webpack_public_path__ + "static/media/W18-1108_AW_Bourbon_Steakhouse_Mobile_Hero_767x845_en.d0f3de4d.jpg";